import {
  setJwtToken,
  instance as axios,
  setMultiPartHeader,
} from "../../config/AxiosInstance";

// ------------Get Feeds Listing-------------
export const feedListApi = async (data) => {
  const endPoint = `user/feed/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------Create Feed-------------
export const createFeedApi = async (data) => {
  return await axios.post(`user/feed`, data, setMultiPartHeader());
};

// ------------Update Feed-------------
export const updateFeedApi = async (data) => {
  return await axios.put(`user/feed`, data, setMultiPartHeader());
};

// ------------Feed Detail Api -------------
export const feedDetailApi = async (data) => {
  const endPoint = `user/feed/` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Reaction on feed
export const feedReactionApi = async (data) => {
  return await axios.put(`user/feed/reaction`, data, setJwtToken());
};

// Comment on feed
export const feedCommentApi = async (data) => {
  return await axios.post(`user/comment`, data, setJwtToken());
};
export const updateCommentApi = async (data) => {
  return await axios.put(`user/comment`, data, setJwtToken());
};

// Feed Comment List
export const feedCommentListApi = async (data) => {
  const endPoint =
    `user/comment/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

//------------update-Feed-Request-Api----------------
export const updateFeedRequestApi = async (data) => {
  return await axios.put(`user/feed/draft/status`, data, setJwtToken());
};

export const feedRequestListApi = async (data) => {
  const endPoint = `user/feed/draft/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};
// -----------delete-Feed-Api -------------
export const deleteFeedApi = async (data) => {
  const endPoint = `user/feed/` + "?" + new URLSearchParams(data).toString();
  return await axios.delete(endPoint, setJwtToken());
};